module.exports = __webpack_public_path__ + "01_long_gray.5d5ddb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_long_gray.png
// module id = a6VL
// module chunks = 0